export default __webpack_public_path__ + "static/media/stats-icon.15b7b54d.svg";